<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_viii"></a><a id="page_xii"></a><a id="page_xiii"></a><strong><em>After the Gold Rush</em></strong></p>
<p class="image"><a id="page_xiv"></a><img alt="Image" src="images/fxiv-01.jpg"/></p>
<p class="caption">Putah Creek and vicinity, northern California, in the second half of the nineteenth century. Ethel Vaught.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?2ac31600